import React, { useEffect, useState } from "react";
import {
  LeftOutlined,
  PrinterOutlined,
  DownloadOutlined,
  ExperimentOutlined,
  DownOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Col, Row, Table, Divider } from "antd";
import * as glanceAwareApi from "../../services/api/glanceaware";
import { Link, useParams } from "react-router-dom";
import tableExport from "antd-table-export";
import MaterialTable from "@material-table/core";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import moment from "moment";
import CustomTable from "../../components/Table/CustomTable";
import useDebounce from '../../components/Table/debounce';

const GlanceAwareTestLogs = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [filter, setFilter] = useState({
    filterBy: '',
    filterValue: ''
  });


  const getGlanceAwareData = async () => {
    try {
      setLoading(true);
      var {
        data: { data, totalCount },
      } = await glanceAwareApi?.getGlanceAware(id, pagination, filter);
      // data = data.map((c) => ({
      //   ...c,
      //   Score: getScore(c),
      // }));
      setPagination((state) => ({ ...state, totalCount: totalCount }));

      const glanceAwareData = [];
      var trueNameDataArray = [];
      const profDataArray = [];
      const array1 = [];
      data.forEach((el) => {
        console.log("-----------------------", el);

        let playwordVal = el.TrueNames;
        let trueNameArr = playwordVal.split(",");

        let trueProf = el.TrueProfession;
        let trueProfArr = trueProf.split(",");

        let nameLength = trueNameArr.length;
        let profLength = trueProfArr.length;

        let selectedAns = el.SelectedNames;
        var selectedNameArr = selectedAns.split(",");

        let selectedProf = el.SelectedProfession;
        var selectedProdArr = selectedProf.split(",");

        trueNameArr.forEach((value, index) => {
          if (value == selectedNameArr[index]) {
            var nameCheck = "true";
          } else {
            var nameCheck = "false";
          }

          if (trueProfArr[index] == selectedProdArr[index]) {
            var professionCheck = "true";
          } else {
            var professionCheck = "false";
          }

          if (el.IsNameCorrect == true && el.IsProfessionCorrect == true) {
            var bothCheck = "BothCorrect";
          } else if (
            el.IsNameCorrect == false &&
            el.IsProfessionCorrect == false
          ) {
            var bothCheck = "BothIncorrect";
          } else {
            var bothCheck = "SingleCorrect";
          }

          console.log("El Data : ", el);

          var nameObj = {
            TrueNames: el.TrueNames,
            // "SelectedNames": selectedNameArr[index],
            SelectedNames: el.SelectedNames,
            OnlyNameCorrect: el.IsNameCorrect,
            FaceAwareId: el.FaceAwareId,
            UserId: el.UserId,
            TrueProfession: el.TrueProfession,
            SelectedProfession: el.SelectedProfession,
            OnlyProfessionCorrect: el.IsProfessionCorrect,
            SessionId: el.SessionId,
            IsThereLossOfMemory: el.IsThereLossOfMemory,
            BothAnswersCorrect: bothCheck,
            LevelType: el.LevelType,
            ReferencePhotoId: el.ReferencePhotoId,
            ShownName: el.ShownName,
            ShownProfession: el.ShownProfession,
            // "Score": getScore(el)
            Score: el.score,
            Date_Created:  el.CreatedDate!=null ? moment(el.CreatedDate).format("MM/DD/Y HH:mm:ss"):'',
            StudyNumber: el.StudyNumber,
            PatientId: el.PatientId,
          };
          trueNameDataArray.push(nameObj);
        });
      });

      // if (id) {
      //   trueNameDataArray = trueNameDataArray.filter((c) => c.UserId == id);
      // }

      setData(trueNameDataArray);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const fetchGlanceAwareData = async (testTube, pagination, filter, studyNumber, participentId) => {
    try {
      var {
        data: { data, totalCount },
      } = await glanceAwareApi?.getGlanceAware(id, pagination, filter);
      var trueNameDataArray = [];
      data.forEach((el) => {

        let playwordVal = el.TrueNames;
        let trueNameArr = playwordVal.split(",");

        let trueProf = el.TrueProfession;
        let trueProfArr = trueProf.split(",");

        let nameLength = trueNameArr.length;
        let profLength = trueProfArr.length;

        let selectedAns = el.SelectedNames;
        var selectedNameArr = selectedAns.split(",");

        let selectedProf = el.SelectedProfession;
        var selectedProdArr = selectedProf.split(",");

        trueNameArr.forEach((value, index) => {
          if (value == selectedNameArr[index]) {
            var nameCheck = "true";
          } else {
            var nameCheck = "false";
          }

          if (trueProfArr[index] == selectedProdArr[index]) {
            var professionCheck = "true";
          } else {
            var professionCheck = "false";
          }

          if (el.IsNameCorrect == true && el.IsProfessionCorrect == true) {
            var bothCheck = "BothCorrect";
          } else if (
            el.IsNameCorrect == false &&
            el.IsProfessionCorrect == false
          ) {
            var bothCheck = "BothIncorrect";
          } else {
            var bothCheck = "SingleCorrect";
          }

          console.log("El Data : ", el);

          var nameObj = {
            TrueNames: el.TrueNames,
            // "SelectedNames": selectedNameArr[index],
            SelectedNames: el.SelectedNames,
            OnlyNameCorrect: el.IsNameCorrect,
            FaceAwareId: el.FaceAwareId,
            UserId: el.UserId,
            TrueProfession: el.TrueProfession,
            SelectedProfession: el.SelectedProfession,
            OnlyProfessionCorrect: el.IsProfessionCorrect,
            SessionId: el.SessionId,
            IsThereLossOfMemory: el.IsThereLossOfMemory,
            BothAnswersCorrect: bothCheck,
            LevelType: el.LevelType,
            ReferencePhotoId: el.ReferencePhotoId,
            ShownName: el.ShownName,
            ShownProfession: el.ShownProfession,
            // "Score": getScore(el)
            Score: el.score,
            Date_Created:  el.CreatedDate!=null ? moment(el.CreatedDate).format("MM/DD/Y HH:mm:ss"):'',
            StudyNumber: el.StudyNumber,
            PatientId: el.PatientId,
          };
          trueNameDataArray.push(nameObj);
        });
      });

      return { data : trueNameDataArray, totalCount };

    } catch (error) {
      console.log(error);
    }
  };

  const getScore = (item) => {
    let i = 0;
    return item.SelectedNames.split(",").reduce((acc, curr) => {
      if (
        item?.TrueNames?.split(",")?.includes(curr) &&
        item?.TrueProfession?.split(",")?.includes(
          item?.SelectedProfession.split(",")[i]
        )
      ) {
        acc++;
      }
      i++;
      return acc;
    }, 0);
  };

  // const columns = [
  //   {
  //     title: "GlanceAware Id",
  //     field: "FaceAwareId",
  //   },
  //   {
  //     title: "UserId",
  //     field: "UserId",
  //   },
  //   {
  //     title: "Session Id",
  //     field: "SessionId",
  //   },
  //   {
  //     title: "Level Type",
  //     field: "LevelType",
  //   },
  //   {
  //     title: "Reference PhotoId",
  //     field: "ReferencePhotoId",
  //   },
  //   {
  //     title: "DisplayedName",
  //     field: "TrueNames",
  //   },
  //   {
  //     title: "DisplayedProfession",
  //     field: "TrueProfession",
  //   },
  //   {
  //     title: "Selected Names",
  //     field: "SelectedNames",
  //   },
  //   {
  //     title: "Selected Profession",
  //     field: "SelectedProfession",
  //   },
  //   {
  //     title: "Shown Name",
  //     field: "ShownName",
  //   },
  //   {
  //     title: "Shown Profession",
  //     field: "ShownProfession",
  //   },
  //   {
  //     title: "BothAnswersCorrect",
  //     field: "BothAnswersCorrect",
  //   },
  //   {
  //     title: "OnlyProfessionCorrect",
  //     field: "OnlyProfessionCorrect",
  //   },
  //   {
  //     title: "OnlyNameCorrect",
  //     field: "OnlyNameCorrect",
  //   },
  //   {
  //     title: "Score",
  //     field: "Score",
  //   },
  //   {
  //     title: "Date",
  //     field: "Date_Created",
  //   },
  // ];

  const columns = [
    {
      Header: "GlanceAware Id",
      accessor: "FaceAwareId",
    },
    {
      Header: "StudyNumber",
      accessor: "StudyNumber",
    },
    {
      Header: "Researcher/PI",
      accessor: "UserId",
    },
    {
      Header: "Participant Id",
      accessor: "PatientId",
    },
    {
      Header: "Session Id",
      accessor: "SessionId",
    },
    {
      Header: "Level Type",
      accessor: "LevelType",
    },
    {
      Header: "Reference Photo Id",
      accessor: "ReferencePhotoId",
    },
    {
      Header: "Displayed Name",
      accessor: "TrueNames",
    },
    {
      Header: "Displayed Profession",
      accessor: "TrueProfession",
    },
    {
      Header: "Selected Names",
      accessor: "SelectedNames",
    },
    {
      Header: "Selected Profession",
      accessor: "SelectedProfession",
    },
    {
      Header: "Shown Name",
      accessor: "ShownName",
    },
    {
      Header: "Shown Profession",
      accessor: "ShownProfession",
    },
    {
      Header: "Both Answers Correct",
      accessor: "BothAnswersCorrect",
    },
    {
      Header: "Only Profession Correct",
      accessor: "OnlyProfessionCorrect",
    },
    {
      Header: "Only Name Correct",
      accessor: "OnlyNameCorrect",
    },
    {
      Header: "Score",
      accessor: "Score",
    },
    {
      Header: "Date",
      accessor: "Date_Created",
    },
  ];

  const exportInstance = new tableExport(data, columns);
  function downloadExcel() {
    exportInstance.download("GlanceAwareTestLogs");
  }

  const debouncedFilterValue = useDebounce(filter.filterValue, 300);

  const handleSearchFilter = (e) => {
    setFilter((state) => ({ ...state, filterValue: e.target.value }))
  };

  useEffect(() => {
    if (debouncedFilterValue !== null) {
      getGlanceAwareData();
    }
  }, [currentPage, debouncedFilterValue]);

  useEffect(() => {
    if (filter) {
      getGlanceAwareData();
    }
  }, [filter])

  var returnPath = "/dashboard";
  if (id) {
    returnPath = "/dashboard/user-details/" + id;
  }
  return (
    <>


      <CustomTable
        columns={columns}
        data={data}
        pagination={pagination}
        setPagination={setPagination}
        loading={loading}
        setCurrentPage={setCurrentPage}
        setFilter={setFilter}
        handleSearchFilter={handleSearchFilter}
        fetchData={fetchGlanceAwareData}
        filter={filter}
        type={'glanceAware'}
      />

    </>
    // <div className="container">
    //   <div className="test-log">
    //     <span className="left-outlined">
    //       <Link to={returnPath}>
    //         <LeftOutlined />
    //       </Link>
    //     </span>
    //     <h2 style={{ fontSize: "32px", color: "white" }}>Test logs</h2>
    //   </div>

    //   <Divider />
    //   <Row className="table-background" gutter={[22, 22]}>
    //     <Col lg={24}>
    //       <MaterialTable
    //         title="GlanceAware"
    //         columns={columns}
    //         data={data}
    //         options={{
    //           exportAllData: true,
    //           exportMenu: [
    //             {
    //               label: "Export PDF",
    //               exportFunc: (columns, data) =>
    //                 ExportPdf(columns, data, "GlanceAware"),
    //             },
    //             {
    //               label: "Export CSV",
    //               exportFunc: (columns, data) =>
    //                 ExportCsv(columns, data, "GlanceAware"),
    //             },
    //           ],
    //           filtering: true,
    //           sorting: true,
    //           headerStyle: {
    //             backgroundColor: "#01579b",
    //             color: "#FFF",
    //           },
    //           cellStyle: {
    //             backgroundColor: "#01579b",
    //             color: "#FFF",
    //           },
    //           pageSize: 10,
    //           pageSizeOptions: [10, 50, 100],
    //         }}
    //       />
    //     </Col>
    //   </Row>
    // </div>
  );
};

export default GlanceAwareTestLogs;
